import { cn } from '@hbs-us/ui';
import { Outlet, useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';
import { analyticsMaskClassForRoute, capturePageView, routeIdForPath } from '../analytics.js';
import { BlockedRouteNotice } from '../BlockedRouteNotice.js';
import { ImpersonationBanner } from '../components/ImpersonationBanner.js';
import { StatusBanner } from '../components/StatusBanner.js';
import { TopBar } from './TopBar.js';

/**
 * The platform shell (the `new_shell` flag-ON chrome): top bar + 9-dot launcher +
 * cmd-K around the routed content. The column layout, the only-`<main>`-scrolls
 * rule, the impersonation banner above the bar, the status strip below it, and
 * the analytics page-view capture + per-route masking are all carried over from
 * the sidebar shell unchanged — the flag swaps the CHROME, never the rules.
 */
export function PlatformShell() {
  const location = useLocation();
  const routeId = routeIdForPath(location.pathname);

  useEffect(() => {
    capturePageView(routeId);
  }, [routeId]);

  return (
    <div className="flex h-dvh flex-col bg-background">
      <ImpersonationBanner />
      <TopBar />
      <StatusBanner />
      {/*
        `min-h-0` is load-bearing (see the shared kit shell): the header column
        must not grow with its content, or `<main>` stops being the only scroller
        and the document reports phantom overflow on mobile.
      */}
      <main
        className={cn(
          'min-h-0 flex-1 overflow-auto overscroll-contain [-webkit-overflow-scrolling:touch]',
          analyticsMaskClassForRoute(routeId),
        )}
      >
        <BlockedRouteNotice />
        <Outlet />
      </main>
    </div>
  );
}
